import sensors from './sensorsdata.es6.min'
import { getEnvData } from './env'

export const getCookieByName = (name) => {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)"); //匹配字段
  if ((arr = document.cookie.match(reg))) {
    return unescape(arr[2]);
  } else {
    return null;
  }
}

const sensorsUrl = getEnvData('sensorsUrl')
sensors.init({
    server_url: sensorsUrl,
    heatmap: {
        //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
        clickmap: 'default',
        //是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
        scroll_notice_map: 'not_collect'
    }
});
const registerPage = (data) => {
  sensors.registerPage(data)
}
const track = (eventName, eventData) => {
    if (!eventName || !eventData) {
        return
    }
    // 神策数据埋点
    sensors.track(eventName, eventData)
}
const login = (id) => {
  sensors.login(id)
}

export default {
  track,
  registerPage,
  login
}



// WEBPACK FOOTER //
// ./src/utils/dataStatistics.js